import { nullishToUndefinedable } from '@cc-shopping/utils/valibot';
import { gql } from 'graphql-tag';
import * as v from 'valibot';

export interface Identity {
  creditScore: number | null;
  approvalOdds?: string;
}

export const IdentitySchema = v.object({
  identity: nullishToUndefinedable(
    v.object(
      {
        creditScore: v.nullable(v.number('creditScore must be a number when provided')),
        approvalOdds: nullishToUndefinedable(
          v.string('approvalOdds must be a string when provided'),
        ),
      },
      'identity must be a valid object',
    ),
  ),
  rawIdentity: nullishToUndefinedable(
    v.object(
      {
        data: v.object(
          {
            identity: v.object(
              {
                id: nullishToUndefinedable(v.string('id must be a string when provided')),
                is_nerdwallet_plus_member: v.nullish(
                  v.boolean('is_nerdwallet_plus_member must be a boolean when provided'),
                  false,
                ),
                roles: v.nullish(
                  v.array(v.string('role must be a string'), 'roles must be an array of strings'),
                  [],
                ),
                shea_id: nullishToUndefinedable(v.string('shea_id must be a string when provided')),
                email: nullishToUndefinedable(v.string('email must be a string when provided')),
              },
              'identity must be a valid object',
            ),
          },
          'data must be a valid object',
        ),
      },
      'rawIdentity must be a valid object',
    ),
  ),
});

export type IdentityResponse = v.InferOutput<typeof IdentitySchema>;

export const IDENTITY_QUERY = gql`
  query UserIsLoggedIn {
    identity: tuCreditReport {
      creditScore: vantageScore3
      approvalOdds: vantageScore3Bucket
    }
    rawIdentity {
      data
    }
  }
`;
